document.addEventListener('DOMContentLoaded',()=>{
  const mq=window.matchMedia('(max-width:800px)');
  const menu=document.querySelector('[data-dx-mobile-panel]');
  const search=document.querySelector('[data-dx-mobile-search-sheet]');
  const filter=document.querySelector('[data-dx-filter-panel]');
  const backdrop=document.querySelector('[data-dx-app-backdrop]');
  const searchToggles=[...document.querySelectorAll('[data-dx-mobile-search-toggle]')];
  const filterToggles=[...document.querySelectorAll('[data-dx-filter-toggle]')];
  const menuToggles=[...document.querySelectorAll('[data-dx-menu-toggle]')];
  const searchInput=document.getElementById('DxMobileSearch');

  const anyOpen=()=>!!(menu?.classList.contains('is-open')||search?.classList.contains('is-open')||filter?.classList.contains('is-open'));
  const sync=()=>{
    if(!mq.matches){if(backdrop)backdrop.hidden=true;document.body.classList.remove('dx-app-lock');return;}
    const open=anyOpen();
    if(backdrop)backdrop.hidden=!open;
    document.body.classList.toggle('dx-app-lock',open);
    if(!open)document.body.style.overflow='';
  };
  const closeAll=()=>{
    if(menu){menu.classList.remove('is-open');menu.setAttribute('aria-hidden','true');}
    if(search){search.classList.remove('is-open');search.setAttribute('aria-hidden','true');}
    if(filter){filter.classList.remove('is-open');filter.setAttribute('aria-hidden','true');}
    searchToggles.forEach(b=>b.setAttribute('aria-expanded','false'));
    filterToggles.forEach(b=>b.setAttribute('aria-expanded','false'));
    menuToggles.forEach(b=>b.setAttribute('aria-expanded','false'));
    document.body.style.overflow='';sync();
  };
  const openSearch=()=>{
    closeAll();if(!search)return;search.classList.add('is-open');search.setAttribute('aria-hidden','false');searchToggles.forEach(b=>b.setAttribute('aria-expanded','true'));sync();requestAnimationFrame(()=>searchInput?.focus());
  };
  const openFilter=()=>{
    closeAll();if(!filter)return;filter.classList.add('is-open');filter.setAttribute('aria-hidden','false');filterToggles.forEach(b=>b.setAttribute('aria-expanded','true'));sync();
  };

  searchToggles.forEach(b=>b.addEventListener('click',openSearch));
  document.querySelectorAll('[data-dx-mobile-search-close]').forEach(b=>b.addEventListener('click',closeAll));
  filterToggles.forEach(b=>b.addEventListener('click',()=>filter?.classList.contains('is-open')?closeAll():openFilter()));
  menuToggles.forEach(b=>b.addEventListener('click',()=>requestAnimationFrame(sync)));
  backdrop?.addEventListener('click',closeAll);
  document.addEventListener('keydown',e=>{if(e.key==='Escape'&&anyOpen())closeAll();});
  mq.addEventListener?.('change',e=>{if(!e.matches)closeAll();});
  if(filter&&mq.matches)filter.setAttribute('aria-hidden','true');
});
